import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import EditBtn from './components/EditBtn';
import { IUserProfileContext, UserProfileContext } from '../../../../userProfileState/userProfileContext';
import style from './UserInfoControlPanel.module.scss';

const UserInfoControlPanel: React.FC = () => {
	const { changeUserInfoVisibleForm, userInfoVisibleForm, userForUserInfo } =
		useContext<IUserProfileContext>(UserProfileContext);

	return (
		<>
			<div className={style.heading}>
				<Text
					className={style.headingText}
					translationKey={`${userForUserInfo?.surName} ${userForUserInfo?.firstName}`}
					size="xxl"
					weight="bold"
				/>
				<EditBtn />
			</div>
			<div className={style.bookMarks}>
				<PageBookmarkBtn
					onClick={() => changeUserInfoVisibleForm('mainForm')}
					isActive={userInfoVisibleForm === 'mainForm'}
					btnName="mainInfoBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeUserInfoVisibleForm('additionally')}
					isActive={userInfoVisibleForm === 'additionally'}
					btnName="additionallyBookmark"
				/>
			</div>
		</>
	);
};

export default UserInfoControlPanel;
